import React from 'react';
import { Route } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import PermissionProtectedRoute from './components/PermissionProtectedRoute'; // Assuming this component exists for permission checks
import Login_v2 from './pages/Login_v2'; // Use the updated Login component
// import Dashboard from './pages/Dashboard'; // Placeholder for dashboard or replace with your actual component
import DashboardHome_v2 from './pages/DashboardHome_v2'; // Placeholder for dashboard or replace with your actual component
import CorporatePage from './pages/CorporatePage';
import CorporateStatusList from './pages/CorporateStatusList';

// Add other page imports as needed based on your project
// Example imports (replace with actual components):
// import ChatbotQueuing from './pages/ChatbotQueuing';
// import Analytics from './pages/Analytics';
// ... other imports ...

import ProfilePage from "./pages/ProfilePage";
import PasswordChangePage from "./pages/PasswordChangePage";
import UserManagement from "./pages/UsersManagement";
import UserEditPage_v2 from "./pages/UserEditPage_v2";
import UserRolePage_v2 from "./pages/UserRolePage_v2";
import UserRolesManagement from "./pages/UserRolesManagement";
import UserRolePermissionsPage_v2 from "./pages/UserRolePermissionsPage_v2";
import UserRoleEditPage_v2 from "./pages/UserRoleEditPage_v2";
import UserPermissionsManagement from "./pages/UserPermissionsManagement";
import CreateNewPermission from "./pages/CreateNewPermission";
import UserPermissionEditPage from "./pages/UserPermissionEditPage";
import FontawesomeIconsDemo from "./pages/FontawesomeIconsDemo";

import CorporateDataTable from './pages/CorporateDataTable';
import CorporateDetails from './pages/CorporateDetails';
import CorporateBillingSetup  from './pages/CorporateBillingSetup';
import BillingCorporateConfigurationTable  from './pages/BillingCorporateConfigurationTable';
import UploadCardFee  from './pages/UploadCardFee';
import UploadCardFeeHistory  from './pages/UploadCardFeeHistory';
import CardFeeProcessedHistory  from './pages/CardFeeProcessedHistory';

import UploadAdminFee  from './pages/UploadAdminFee';
import UploadAdminFeeHistory  from './pages/UploadAdminFeeHistory';
import AdminFeeProcessedHistory  from './pages/AdminFeeProcessedHistory';

import AdminFeeHistory  from './pages/Billing/AdminFeeHistory';
import AdminFee  from './pages/Billing/AdminFee';
import AdminFeeDetails  from './pages/Billing/AdminFeeDetails';

import BillingForBilling  from './pages/Billing/BillingForBilling';
import NetworkAccessFee  from './pages/Billing/NetworkAccessFee';
import NetworkAccessFeeHistory  from './pages/Billing/NetworkAccessFeeHistory';
import NetworkAccessFeeDetails  from './pages/Billing/NetworkAccessFeeDetails';


import CardPrintingFee  from './pages/Billing/CardPrintingFee';
import CardPrintingFeeHistory  from './pages/Billing/CardPrintingFeeHistory';
import CardPrintingFeeDetails  from './pages/Billing/CardPrintingFeeDetails';

import CardReplacementFee  from './pages/Billing/CardReplacementFee';
import CardReplacementFeeHistory  from './pages/Billing/CardReplacementFeeHistory';
import CardReplacementFeeDetails  from './pages/Billing/CardReplacementFeeDetails';

import CollectionsHistory  from './pages/Billing/CollectionsHistory';

import InterestFee  from './pages/Billing/InterestFee';
import InterestFeeGenerate  from './pages/Billing/InterestFeeGenerate';
import InterestFeeHistory  from './pages/Billing/InterestFeeHistory';
import InterestFeeDetails  from './pages/Billing/InterestFeeDetails';
import CollectionDashboard  from './pages/Billing/CollectionDashboard';
import BillingAnalysis  from './pages/Billing/BillingAnalysis';

import Reports  from './pages/Billing/Reports';
import CorporateSetup from './pages/update_corp_prefix/CorporateSetup';

// Public Routes
export const publicRoutes = (
  <Route
    path="/login"
    element={
      <GoogleReCaptchaProvider reCaptchaKey="6Lfr6dwqAAAAAM40hrOttRrUdRRShlIoC6Qi0NN1">
        <Login_v2 />
      </GoogleReCaptchaProvider>
    }
  />
);

// Protected Routes (authentication required)
export const protectedRoutes = [
  // { path: "/dashboard", element: <Dashboard /> },
  { path: "/dashboard", element: <DashboardHome_v2 /> },
  { path: "/corporate/list", element: <CorporatePage /> },
  { path: "/corporate/status-list", element: <CorporateStatusList /> },
  // Add more protected routes here as needed
];

// Permission-Protected Routes
export const permissionRoutes = [
  // { path: "/analytics", element: <Analytics />, permission: "access_page" },
  // Add more permission-based routes as needed based on your sample
  // Example:
  // { path: "/settings", element: <Settings />, permission: "delete_page" },
  { path: "/profile", element: <ProfilePage />, permission: "access_page" },
  { path: "/change-password", element: <PasswordChangePage />, permission: "access_page" },
  { path: "/users", element: <UserManagement />, permission: "access_page" },
  { path: "/users/edit/:username", element: <UserEditPage_v2 />, permission: "access_page" },
  { path: "/users/roles/:username", element: <UserRolePage_v2 />, permission: "access_page" },
  { path: "/roles", element: <UserRolesManagement />, permission: "access_page" },
  { path: "/roles/edit/:roleId", element: <UserRoleEditPage_v2 />, permission: "access_page" },
  { path: "/roles/permissions/:roleId", element: <UserRolePermissionsPage_v2 />, permission: "access_page" },
  { path: "/permissions", element: <UserPermissionsManagement />, permission: "access_page" },
  { path: "/permissions/create", element: <CreateNewPermission />, permission: "access_page" },
  { path: "/permissions/edit/:permissionId", element: <UserPermissionEditPage />, permission: "access_page" },
  { path: "/FontawesomeIconsDemo", element: <FontawesomeIconsDemo />, permission: "access_page" },

  // Billing Corp Settings Fees
  { path: "/corporate-settings", element: <CorporateDataTable />, permission: "access_page" },
  { path: "/corporate-view-settings", element: <BillingCorporateConfigurationTable />, permission: "access_page" },
  { path: "/corporate-settings/details/:corp_code", element: <CorporateDetails  />, permission: "access_page" },
  { path: "/corporate-settings/setup/:corp_code", element: <CorporateBillingSetup  />, permission: "access_page" },
  { path: "/corporate-settings/update-corp-prefix/:corp_code", element: <CorporateSetup  />, permission: "access_page" },

  // Upload Card Replacement Fee
  { path: "/card-replacement-fee/upload-card-replacement-fee", element: <UploadCardFee  />, permission: "access_page" },
  { path: "/card-replacement-fee/upload-card-replacement-fee-history", element: <UploadCardFeeHistory  />, permission: "access_page" },
  { path: "/card-replacement-fee/processed", element: <CardFeeProcessedHistory />, permission: "access_page" },
  // Card Replacement Fee Billed
  { path: "/billing/card-replacement-fee", element: <CardReplacementFee />, permission: "access_page" },
  { path: "/billing/card-replacement-fee-billed", element: <CardReplacementFeeHistory />, permission: "access_page" },
  { path: "/billing/card-replacement-fee-billed/:seriesNoUid", element: <CardReplacementFeeDetails />, permission: "access_page" },

  // <Route path="/billing/card-replacement-fee" element={<CardReplacementFee />} />
  // <Route path="/billing/card-replacement-fee-billed" element={<CardReplacementFeeHistory />} />
  // <Route path="/billing/card-replacement-fee-billed/:seriesNoUid" element={<CardReplacementFeeDetails />} />


  { path: "/admin-fee/upload-admin-fee", element: <UploadAdminFee  />, permission: "access_page" },
  { path: "/admin-fee/upload-admin-fee-history", element: <UploadAdminFeeHistory  />, permission: "access_page" },
  { path: "/admin-fee/processed", element: <AdminFeeProcessedHistory />, permission: "access_page" },


  // Billing (NAF) Network Accss Fee
  // { path: "/billing/network-access/for-billing", element: <BillingForBilling />, permission: "access_page" },
  { path: "/billing/network-access-fee", element: <NetworkAccessFee />, permission: "access_page" },
  { path: "/billing/network-access-fee-billed", element: <NetworkAccessFeeHistory />, permission: "access_page" },
  { path: "/billing/network-access-fee-billed/:seriesNoUid", element: <NetworkAccessFeeDetails />, permission: "access_page" },


    // Billing Admin Fee
  { path: "/billing/admin-fee", element: <AdminFee />, permission: "access_page" },
  { path: "/billing/admin-fee-billed", element: <AdminFeeHistory />, permission: "access_page" },
  { path: "/billing/admin-fee-billed/:seriesNoUid", element: <AdminFeeDetails />, permission: "access_page" },

  // <Route path="/billing/network-access" element={<BillingForBilling />} />
  // <Route path="/billing/network-access/sales-invoice" element={<NetworkAccessFee />} />
  // <Route path="/billing/network-access/statement-of-account" element={<NetworkAccessFee />} />
  // <Route path="/billing/network-access/history" element={<NetworkAccessFeeHistory />} />
  // <Route path="/billing/network-access/series/:seriesNo" element={<NetworkAccessFeeDetails />} />


  // Billing (CPF) Card Printing Fee
  // { path: "/billing/network-access/for-billing", element: <BillingForBilling />, permission: "access_page" },
  { path: "/billing/card-printing-fee", element: <CardPrintingFee />, permission: "access_page" },
  { path: "/billing/card-printing-fee-billed", element: <CardPrintingFeeHistory />, permission: "access_page" },
  { path: "/billing/card-printing-fee-billed/:seriesNoUid", element: <CardPrintingFeeDetails />, permission: "access_page" },

  


  // Collections
  
  { path: "/collections/dashboard", element: <CollectionDashboard />, permission: "access_page" },
  { path: "/collections/analysis", element: <BillingAnalysis />, permission: "access_page" },
  { path: "/collections/list", element: <CollectionsHistory />, permission: "access_page" },

  { path: "/billing/card-printing-fee-billed", element: <CollectionsHistory />, permission: "access_page" },
  { path: "/billing/card-printing-fee-billed/:seriesNoUid", element: <CollectionsHistory />, permission: "access_page" },


  // - **Routing**:
  // - Add a route for `InterestFeeHistory.jsx` in your React app, e.g., `/billing/interest-fee-history`.
  // - Add a route for `InterestFeeDetails.jsx` (if created) at `/billing/interest-fee-series/:seriesNoUid`.

  // { path: "/billing/interest-fee", element: <InterestFee />, permission: "access_page" },
  { path: "/billing/interest-fee", element: <InterestFeeGenerate />, permission: "access_page" },
  { path: "/billing/interest-fee-billed", element: <InterestFeeHistory />, permission: "access_page" },

  { path: "/billing/interest-fee-billed/:seriesNoUid", element: <InterestFeeDetails />, permission: "access_page" },
  
  { path: "/reports", element: <Reports />, permission: "access_page" },



].map((route) => ({
  ...route,
  element: (
    <PermissionProtectedRoute requiredPermission={route.permission}>
      {route.element}
    </PermissionProtectedRoute>
  ),
}));